import backend from '../apis/backend';

export default async (request) => {
  try {
    return (await backend(request)).data;
  } catch (err) {
    if (err.response?.status === 401)
     // window.location.reload();

    return err.response?.data
      ? err.response.data
      : {status: 503, message: err.message || 'Service Unavailable'};
  }
};
